document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', (event) => {
    const toggler = event.target.closest('.js-tooltip-toggler');
    if (toggler) {
        toggleTooltip(event);
    }
});

document.body.addEventListener('keydown', (event) => {
    const toggler = event.target.closest('.js-tooltip-toggler');
    if (toggler) {
        handleKeydown(event);
    }
});
  
function toggleTooltip(event) {
  const toggler = event.target.closest('.js-tooltip-toggler');
  const targetId = toggler.getAttribute('data-target');
  const tooltip = document.getElementById(targetId);
  
  if (tooltip) {
      const isOpening = !tooltip.classList.contains('tooltip--active');
      tooltip.classList.toggle('tooltip--active');
      
      if (isOpening) {
          const firstFocusable = tooltip.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          if (firstFocusable) {
              firstFocusable.focus();
          }
      } else {
          toggler.focus();
      }
  }
}
  
    function handleKeydown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleTooltip(event);
      } else if (event.key === 'Escape') {
        const targetId = event.currentTarget.getAttribute('data-target');
        const tooltip = document.getElementById(targetId);
        
        if (tooltip && tooltip.classList.contains('tooltip--active')) {
          tooltip.classList.remove('tooltip--active');
          event.currentTarget.focus();
        }
      }
    }
  
    // Trap focus within the active tooltip
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        const activeTooltip = document.querySelector('.tooltip.tooltip--active');
        if (activeTooltip) {
          const focusableElements = activeTooltip.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          const firstFocusable = focusableElements[0];
          const lastFocusable = focusableElements[focusableElements.length - 1];
  
          if (event.shiftKey && document.activeElement === firstFocusable) {
            event.preventDefault();
            lastFocusable.focus();
          } else if (!event.shiftKey && document.activeElement === lastFocusable) {
            event.preventDefault();
            firstFocusable.focus();
          }
        }
      }
    });
  });